let getToken = null;

export const setSessionTokenGetter = (getter) => {
  getToken = getter;
};

export const getSessionToken = () => getToken?.() ?? Promise.resolve(null);
